// components/DocumentTypeCombobox.tsx
import { Combobox } from "@headlessui/react";
import clsx from "clsx";
import { Check, ChevronDown } from "lucide-react";
import { useState } from "react";
import DOCUMENT_TYPES from "../../types-docs.json";

// const DOCUMENT_TYPES = [
//   {
//     label: "Dossier de projet",
//     value: 100,
//     children: [
//       { label: "Statuts de l’association / entreprise", value: 1 },
//       { label: "Présentation du projet (fiche projet)", value: 2 },
//       { label: "Budget prévisionnel", value: 3 },
//       { label: "Attestation d’ouverture de compte bancaire", value: 4 },
//       { label: "CV ou biographies des porteurs de projet", value: 5 },
//       { label: "Lettre d’engagement / convention", value: 6 },
//       { label: "Cartographie du terrain", value: 7 },
//       { label: "Plan d’action / calendrier prévisionnel", value: 8 },
//     ],
//   },
//   {
//     label: "Certification",
//     value: 200,
//     children: [{ label: "Certificat", value: 9 }],
//   },
// ];

const flatOptions = DOCUMENT_TYPES.flatMap((group) =>
  group.children.map((child) => ({
    ...child,
    groupLabel: group.label,
  }))
);

export default function DocumentTypeCombobox({
  value,
  onChange,
}: {
  value: number | null;
  onChange: (v: number | null) => void;
}) {
  const [query, setQuery] = useState("");
  const filtered =
    query === ""
      ? flatOptions
      : flatOptions.filter((item) =>
          item.label.toLowerCase().includes(query.toLowerCase())
        );

  const selectedOption = flatOptions.find((o) => o.value === value) ?? null;

  return (
    <Combobox value={value} onChange={onChange}>
      <div className="relative w-full">
        <Combobox.Input
          className="w-full border rounded py-2 pl-2 pr-5 text-sm truncate"
          placeholder="Rechercher ou sélectionner un type..."
          displayValue={() => selectedOption?.label ?? ""}
          onChange={(e) => setQuery(e.target.value)}
        />
        <Combobox.Button className="absolute inset-y-0 right-2 flex items-center">
          <ChevronDown className="w-4 h-4 text-gray-500" />
        </Combobox.Button>
        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {filtered.length === 0 ? (
            <div className="px-4 py-2 text-gray-500">Aucun résultat</div>
          ) : (
            DOCUMENT_TYPES.map((group) => {
              const children = filtered.filter(
                (item) => item.groupLabel === group.label
              );
              if (children.length === 0) return null;
              return (
                <div key={group.value} className="px-2 py-1">
                  <div className="text-xs text-gray-500 font-medium px-2 py-1">
                    {group.label}
                  </div>
                  {children.map((item) => (
                    <Combobox.Option
                      key={item.value}
                      value={item.value}
                      className={({ active, selected }) =>
                        clsx(
                          "cursor-pointer px-3 py-1.5 rounded flex justify-between items-center",
                          active && "bg-[#1d5215] text-white",
                          selected && "font-medium"
                        )
                      }
                    >
                      {({ selected }) => (
                        <>
                          <span className="line-clamp-1">{item.label}</span>
                          {selected && <Check className="w-4 h-4" />}
                        </>
                      )}
                    </Combobox.Option>
                  ))}
                </div>
              );
            })
          )}
        </Combobox.Options>
      </div>
    </Combobox>
  );
}
